"use client";

import { useTranslations } from "next-intl";
import { IconArrowLeft } from "@/components/icons";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import MuiLink from "@mui/material/Link";
import { Link } from "@/i18n/navigation";
import { navLabelSx } from "@/theme/tokens";
import { Wordmark } from "@/components/common/Wordmark";
import { StartCta } from "@/components/landing/StartCta";

/**
 * Slim top bar for every sub-page (FAQ, press, legal, 404): the wordmark and
 * a back link routing to the home page in the active locale, plus the primary
 * "Get Started" CTA so the funnel stays reachable off the landing page.
 */
export function PageTopBar() {
  const t = useTranslations("legal");
  const tHeader = useTranslations("header");
  return (
    <Box sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
      <Container
        maxWidth="lg"
        sx={{
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <MuiLink component={Link} href="/" underline="none">
          <Wordmark fontSize="1.2rem" />
        </MuiLink>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: { xs: 2, sm: 3 } }}
        >
          <MuiLink
            component={Link}
            href="/"
            underline="none"
            color="text.secondary"
            aria-label={t("backToHome")}
            sx={{
              ...navLabelSx,
              display: "inline-flex",
              alignItems: "center",
              gap: 0.75,
              whiteSpace: "nowrap",
            }}
          >
            <IconArrowLeft size={16} />
            {/* Icon-only on phones to keep the bar on a single line. */}
            <Box
              component="span"
              sx={{ display: { xs: "none", sm: "inline" } }}
            >
              {t("backToHome")}
            </Box>
          </MuiLink>
          <StartCta
            variant="contained"
            size="small"
            sx={{ whiteSpace: "nowrap", flexShrink: 0 }}
          >
            {tHeader("cta")}
          </StartCta>
        </Box>
      </Container>
    </Box>
  );
}
